<template>
  <div class="wrapper">
    <div class="links-holder">
      <router-link to="/faq">{{ $t('constants.faq') | upperCase }}</router-link>
      <v-divider vertical></v-divider>
      <router-link to="/termsandconditions">{{ $t('constants.tAndC') | upperCase }}</router-link>
      <v-divider vertical></v-divider>
      <router-link to="/privacypolicy">{{ $t('constants.privacyPolicy') | upperCase }}</router-link>
    </div>

    <v-divider class="mt-5" width="100%" />

    <div class="d-flex mt-3 align-center">
      <div v-if="isArkGroup" class="links">
        <p class="copyright mb-0 size-medium">
          {{ $t('constants.copyrightArkGroup') }}
        </p>
      </div>
      <div v-else class="links">
        <p v-if="!hideCopyRight" class="copyright mb-0 size-medium">
          {{ $t('constants.copyright') | upperFirst }} - {{ currentYear }}
        </p>
      </div>

      <language-select :language="wlLanguage" class="ml-5" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import LanguageSelect from '@/components/ui/CLanguageSelect';

const HIDE_COPYRIGHT_FOR_BLUE = 'seeadoctor.blueunitedhealth.com';
const ARK_GROUP_DOMAIN = 'arkgroupmd.com';

export default {
  name: 'StaticLinks',
  components: {
    LanguageSelect,
  },
  data: () => ({
    currentYear: new Date().getFullYear(),
  }),
  computed: {
    ...mapState('common', ['whiteLabel']),
    wlLanguage() {
      return this.whiteLabel ? this.whiteLabel.language : null;
    },
    hideCopyRight() {
      console.log('whiteLabel=', this.whiteLabel);
      return this.whiteLabel && this.whiteLabel.domain === HIDE_COPYRIGHT_FOR_BLUE;
    },
    isArkGroup() {
      return this.whiteLabel && this.whiteLabel.domain === ARK_GROUP_DOMAIN;
    },
    wlLabelTitle() {
      return this.whiteLabel ? this.whiteLabel.label : 'Careclix';
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  min-height: 30px;
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;

  .links-holder {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;

    a {
      padding: 5px;
      color: $grey-dark;
      text-decoration: none;
      position: relative;

      @include until('sm') {
        font-size: 12px;
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }
  .links {
    white-space: nowrap;

    .copyright {
      margin: 0;
      text-align: center;
      letter-spacing: 0.1px;
      color: $grey-light;
      font-style: italic;
    }
  }
}
</style>
